import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';

@Component({
  selector: 'app-efficiency',
  templateUrl: './efficiency.component.html',
  styleUrls: ['./efficiency.component.css']
})

export class EfficiencyComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Efficiency";

  ngOnInit(): void {
    this.getDefaultProject();
    this.loadAllProjects();
    this.replaceSpace();
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
  }

  dt = new Date();
  month: number;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = "E";

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  days = new Array();

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date(yyyy, MM, numOfDays);
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  defaultProjectID: any;

  getDefaultProject() {
    // this.defaultProjectID = Number(sessionStorage.getItem('projectID'));
    // this.projectID = this.defaultProjectID;
  }

  projectID = null;
  projectList = [];

  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];
      }

    }, err => {

    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["NAME", "User"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  billableData = [];
  nonBillableData = [];
  totalOfBillableNonBillableData = [];

  date = new Date();

  getUserWiseSummary(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }

    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith("a") ? "asc" : "desc";

      } catch (error) {
        sort = "";
      }



      if (this.searchText != "") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2)

      }

      this.applyFilter();

      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;

      this._apiService.getUserEfficiencySummary(this.pageIndex, this.pageSize, 'NAME', sort, '', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;
        this.billableData = data['BILLABLE'];
        this.nonBillableData = data['NON_BILLABLE'];
        this.totalOfBillableNonBillableData = data['TOTAL'];
      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });
    }
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";
  PROJECT_DATE = null;

  applyFilter() {
    this.getMonthAndYear();
    this.getDaysOfMonth(this.month, this.year);

    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible";


  }

  getDaysOfMonth(MM, yyyy) {

    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');
    var d = new Date(this.START_DATE).getDate();


    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    var e = new Date(this.END_DATE).getDate();


    for (var i = d; i <= e; i++) {
      var date = new Date(yyyy, MM, i);
      if (date != null) {
        this.days.push(this.datePipe.transform(date, 'yyyy-MM-dd'));
      }
    }
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.PROJECT_DATE = null;
    this.projectID = null;

    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.getUserWiseSummary(true);
    this.radioValue = "E";
  }
  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'asc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;

    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getUserWiseSummary();
    }
  }

  onEnterGetUserWiseSummary() {
    document.getElementById('button1').focus();
    this.getUserWiseSummary(true);
  }
  loadprojectexcel: boolean = false;
  importInExcel() {
    var billableArry1 = [];
    var nonBillableArry1 = [];
    var totalArry1 = [];
    var billableObj1: any = new Object();
    var nonBillableObj1: any = new Object();
    var totalObj1: any = new Object();

    var billableArry2 = [];
    var nonBillableArry2 = [];
    var totalArry2 = [];
    var billableObj2: any = new Object();
    var nonBillableObj2: any = new Object();
    var totalObj2: any = new Object();

    var billableArry3 = [];
    var nonBillableArry3 = [];
    var totalArry3 = [];
    var billableObj3: any = new Object();
    var nonBillableObj3: any = new Object();
    var totalObj3: any = new Object();


    this.loadprojectexcel = true;
    // Get Data for Excel Sheet
    this._apiService.getUserEfficiencySummary(0, 0, 'NAME', 'asc', '', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      if (data['code'] == 200) {
        this.loadprojectexcel = false;
        this.billableData = data['BILLABLE'];
        this.nonBillableData = data['NON_BILLABLE'];
        this.totalOfBillableNonBillableData = data['TOTAL'];
        // hh:mm:ss
        for (var i = 0; i < this.billableData.length; i++) {
          billableObj1['Name'] = this.billableData[i]['NAME'];

          for (var j = 0; j < this.billableProjectList.length; j++) {
            billableObj1[this.billableProjectList[j]['NAME']] = this._apiService.convertIntoHMS(Number(this.billableData[i][this.billableProjectList[j]['ABBREVATION']]));

            if (j == this.billableProjectList.length - 1) {
              billableArry1.push(Object.assign({}, billableObj1));
            }
          }
        }

        for (var i = 0; i < this.nonBillableData.length; i++) {
          nonBillableObj1['Name'] = this.nonBillableData[i]['NAME'];

          for (var j = 0; j < this.nonBillableProjectList.length; j++) {
            nonBillableObj1[this.nonBillableProjectList[j]['NAME']] = this._apiService.convertIntoHMS(Number(this.nonBillableData[i][this.nonBillableProjectList[j]['ABBREVATION']]));

            if (j == this.nonBillableProjectList.length - 1) {
              nonBillableArry1.push(Object.assign({}, nonBillableObj1));
            }
          }
        }

        for (var i = 0; i < this.totalOfBillableNonBillableData.length; i++) {
          totalObj1['Name'] = this.totalOfBillableNonBillableData[i]['NAME'];
          totalObj1['Expected Hrs'] = this.totalOfBillableNonBillableData[i]['EXPECTED_HRS'] + 'h';
          totalObj1['Billable Hrs'] = this._apiService.convertIntoHMS(Number(this.totalOfBillableNonBillableData[i]['TOTAL_BILLABLE_HRS']));
          totalObj1['Non Billable Hrs'] = this._apiService.convertIntoHMS(Number(this.totalOfBillableNonBillableData[i]['TOTAL_NON_BILLABLE_HRS']));
          totalObj1['Total Hrs'] = this._apiService.convertIntoHMS(Number(this.totalOfBillableNonBillableData[i]['TOTAL_HRS']));
          totalObj1['Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['BILLABLE_EFFICIENCY'];
          totalObj1['Non Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['NON_BILLABLE_EFFICIENCY'];
          totalObj1['Total Efficiency'] = this.totalOfBillableNonBillableData[i]['TOTAL_EFFICIENCY'];

          totalArry1.push(Object.assign({}, totalObj1));
        }

        // Total Seconds
        for (var i = 0; i < this.billableData.length; i++) {
          billableObj2['Name'] = this.billableData[i]['NAME'];

          for (var j = 0; j < this.billableProjectList.length; j++) {
            billableObj2[this.billableProjectList[j]['NAME']] = this.billableData[i][this.billableProjectList[j]['ABBREVATION']];

            if (j == this.billableProjectList.length - 1) {
              billableArry2.push(Object.assign({}, billableObj2));
            }
          }
        }

        for (var i = 0; i < this.nonBillableData.length; i++) {
          nonBillableObj2['Name'] = this.nonBillableData[i]['NAME'];

          for (var j = 0; j < this.nonBillableProjectList.length; j++) {
            nonBillableObj2[this.nonBillableProjectList[j]['NAME']] = this.nonBillableData[i][this.nonBillableProjectList[j]['ABBREVATION']];

            if (j == this.nonBillableProjectList.length - 1) {
              nonBillableArry2.push(Object.assign({}, nonBillableObj2));
            }
          }
        }

        for (var i = 0; i < this.totalOfBillableNonBillableData.length; i++) {
          totalObj2['Name'] = this.totalOfBillableNonBillableData[i]['NAME'];
          totalObj2['Expected Hrs'] = this.totalOfBillableNonBillableData[i]['EXPECTED_HRS'] + 'h';
          totalObj2['Billable Hrs'] = this.totalOfBillableNonBillableData[i]['TOTAL_BILLABLE_HRS'];
          totalObj2['Non Billable Hrs'] = this.totalOfBillableNonBillableData[i]['TOTAL_NON_BILLABLE_HRS'];
          totalObj2['Total Hrs'] = this.totalOfBillableNonBillableData[i]['TOTAL_HRS'];
          totalObj2['Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['BILLABLE_EFFICIENCY'];
          totalObj2['Non Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['NON_BILLABLE_EFFICIENCY'];
          totalObj2['Total Efficiency'] = this.totalOfBillableNonBillableData[i]['TOTAL_EFFICIENCY'];

          totalArry2.push(Object.assign({}, totalObj2));
        }

        // Total(Seconds/ 3600)
        for (var i = 0; i < this.billableData.length; i++) {
          billableObj3['Name'] = this.billableData[i]['NAME'];

          for (var j = 0; j < this.billableProjectList.length; j++) {
            billableObj3[this.billableProjectList[j]['NAME']] = parseFloat(String(Number(this.billableData[i][this.billableProjectList[j]['ABBREVATION']]) / 3600)).toFixed(2);

            if (j == this.billableProjectList.length - 1) {
              billableArry3.push(Object.assign({}, billableObj3));
            }
          }
        }

        for (var i = 0; i < this.nonBillableData.length; i++) {
          nonBillableObj3['Name'] = this.nonBillableData[i]['NAME'];

          for (var j = 0; j < this.nonBillableProjectList.length; j++) {
            nonBillableObj3[this.nonBillableProjectList[j]['NAME']] = parseFloat(String(Number(this.nonBillableData[i][this.nonBillableProjectList[j]['ABBREVATION']]) / 3600)).toFixed(2);

            if (j == this.nonBillableProjectList.length - 1) {
              nonBillableArry3.push(Object.assign({}, nonBillableObj3));
            }
          }
        }

        for (var i = 0; i < this.totalOfBillableNonBillableData.length; i++) {
          totalObj3['Name'] = this.totalOfBillableNonBillableData[i]['NAME'];
          totalObj3['Expected Hrs'] = this.totalOfBillableNonBillableData[i]['EXPECTED_HRS'] + 'h';
          totalObj3['Billable Hrs'] = parseFloat(String(Number(this.totalOfBillableNonBillableData[i]['TOTAL_BILLABLE_HRS']) / 3600)).toFixed(2);
          totalObj3['Non Billable Hrs'] = parseFloat(String(Number(this.totalOfBillableNonBillableData[i]['TOTAL_NON_BILLABLE_HRS']) / 3600)).toFixed(2);
          totalObj3['Total Hrs'] = parseFloat(String(Number(this.totalOfBillableNonBillableData[i]['TOTAL_HRS']) / 3600)).toFixed(2);
          totalObj3['Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['BILLABLE_EFFICIENCY'];
          totalObj3['Non Billable Efficiency'] = this.totalOfBillableNonBillableData[i]['NON_BILLABLE_EFFICIENCY'];
          totalObj3['Total Efficiency'] = this.totalOfBillableNonBillableData[i]['TOTAL_EFFICIENCY'];

          totalArry3.push(Object.assign({}, totalObj3));
        }

        this._exportService.multipleTableExportAsExcel(billableArry1, nonBillableArry1, totalArry1, 'Efficiency (HH:MM:SS)');
        this._exportService.multipleTableExportAsExcel(billableArry2, nonBillableArry2, totalArry2, 'Efficiency (In Seconds)');
        this._exportService.multipleTableExportAsExcel(billableArry3, nonBillableArry3, totalArry3, 'Efficiency');
      } else {
        this.loadprojectexcel = false;
      }
    }, err => {
      this.loadprojectexcel = false;
    });
  }

  billableProjectNameKeys = [];
  billableProjectList = [];

  nonBillableProjectNameKeys = [];
  nonBillableProjectList = [];

  replaceSpace() {
    this.billableProjectNameKeys = [];
    this.billableProjectList = [];

    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_BILLABLE=1').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.billableProjectList = projectData['data'];

        for (var i = 0; i < this.billableProjectList.length; i++) {
          var a = [];
          a[0] = (this.billableProjectList[i]['ABBREVATION']);
          a[1] = (this.billableProjectList[i]['ABBREVATION']);
          a[2] = (this.billableProjectList[i]['NAME']);

          this.billableProjectNameKeys.push(a);
        }

      }

    }, err => {

    });

    this.nonBillableProjectNameKeys = [];
    this.nonBillableProjectList = [];

    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_BILLABLE=0').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.nonBillableProjectList = projectData['data'];

        for (var i = 0; i < this.nonBillableProjectList.length; i++) {
          var a = [];
          a[0] = (this.nonBillableProjectList[i]['ABBREVATION']);
          a[1] = (this.nonBillableProjectList[i]['ABBREVATION']);
          a[2] = (this.nonBillableProjectList[i]['NAME']);

          this.nonBillableProjectNameKeys.push(a);
        }

      }

    }, err => {

    });
  }

  // Getting Users
  assigneeList = [];
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' AND IS_ACTIVE=1').subscribe(userData => {
      if (userData['code'] == 200) {
        this.assigneeList = userData['data'];
        var userCategory = this.assigneeList.filter(x => x.ID == this._apiService.userId);
        if (userCategory != null && userCategory != undefined) {
          this.categoryID = userCategory[0]['TASK_CATEGORY_ID'];
        } else {
          this.categoryID = 0;
        }
        this.loadAllRoles();
      }

    }, err => {

    });
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    // level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {

      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {

      });
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = "";

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']) {
          if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
            this.newAssigneeList.push(this.assigneeList[k]);

          } else if (this.cookie.get("level") == "4") {
            if (Number(this.assigneeList[k]['TASK_CATEGORY_ID']) == this.categoryID) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }

          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
    }
    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + (-1));

      return endValue <= new Date(previousDate);
    };
  }

  changeRadioButton(radioButtonValue, apply = false) {
    if (radioButtonValue == "A") {
      let currentDate = new Date();
      this.START_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "B") {
      let currentDate = new Date();
      let previousDate = currentDate.setDate(currentDate.getDate() + (-1));

      this.START_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "C") {
      let currentDate = new Date();
      let previous6thDayDate = currentDate.setDate(currentDate.getDate() + (-6));
      let next7thDayDate = currentDate.setDate(currentDate.getDate() + (6));

      this.START_DATE = this.datePipe.transform(previous6thDayDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(next7thDayDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "D") {
      let currentDate = new Date();
      let lastMonth = currentDate.getMonth() + (-1);
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, lastMonth + 1, 0).getDate();

      let d = new Date(currentYear, lastMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, lastMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    } else if (radioButtonValue == "E") {
      let currentDate = new Date();
      let currentMonth = currentDate.getMonth();
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, currentMonth + 1, 0).getDate();

      let d = new Date(currentYear, currentMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, currentMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    }

    if (apply) {
      this.applyWithRadioButtons();
    }
  }

  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;

    this._apiService.getUserEfficiencySummary(this.pageIndex, this.pageSize, 'NAME', 'asc', '', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      this.loadingRecords = false;



      this.billableData = data['BILLABLE'];



      this.nonBillableData = data['NON_BILLABLE'];



      this.totalOfBillableNonBillableData = data['TOTAL'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
}
